// ─────────────────────────────────────────────────────────────
// LegalPage.js
// Standalone, linkable pages for the privacy policy and terms of service.
//
// These exist because the policies previously lived only in footer modals with
// no URL, and the Telnyx toll-free verification filing has to cite each one by
// address. The footer modals still work; this renders the same exported bodies
// without the modal chrome, so there is exactly one copy of each document.
//
// Routed at /privacy and /terms in App.js. Firebase Hosting rewrites all paths
// to index.html (see firebase.json), so these resolve on a cold load, not just
// via in-app navigation — which matters, since a reviewer pastes the URL fresh.
// ─────────────────────────────────────────────────────────────

import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PrivacyPolicyBody } from './PrivacyPolicyModal';
import { TermsBody } from './TermsModal';
import SITE from '../site';

function LegalPage({ doc }) {
  const isTerms = doc === 'terms';

  useEffect(() => {
    document.title = isTerms
      ? `Terms of Service · ${SITE.name}`
      : `Privacy Policy · ${SITE.name}`;
  }, [isTerms]);

  return (
    <div style={{
      maxWidth: '720px', margin: '0 auto', padding: '1.5rem 1.1rem 3rem',
    }}>
      <div className="modal-box" style={{
        maxHeight: 'none', width: 'auto', margin: 0,
      }}>
        {isTerms ? <TermsBody /> : <PrivacyPolicyBody />}

        <div style={{
          marginTop: '1.25rem', paddingTop: '0.9rem',
          borderTop: '0.5px solid rgba(0,0,0,.12)',
          display: 'flex', gap: '1rem', fontSize: '13px',
        }}>
          <Link to="/">← Back to {SITE.name}</Link>
          <Link to={isTerms ? '/privacy' : '/terms'}>
            {isTerms ? 'Privacy Policy' : 'Terms of Service'}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default LegalPage;
